import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Link, useHistory, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import Box from '../../../../Global/Box'
import InputController from '../../../../Global/InputController'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import ContentHeader from '../../../../Layout/ContentHeader'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import { backPage } from '../Status'
import {
  CREATE_STATUS,
  GET_ALL_STATUS,
  GET_ONE_STATUS,
  UPDATE_STATUS,
} from '../../../../../graphql/Catalog/Status/status'

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Campo requerido'),
  type: Yup.string().required('Campo requerido'),
  description: Yup.string().nullable().required('Campo requerido'),
})

export const StatusAdd = () => {
  const { id: _id } = useParams()
  const { showLoading, hideLoading } = useLoading()
  const history = useHistory()

  const [progressValue, setProgressValue] = useState(0)

  //MUTATIONS
  const [createMutation] = useMutation(CREATE_STATUS, {
    refetchQueries: [
      {
        query: GET_ALL_STATUS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  const [updateMutation] = useMutation(UPDATE_STATUS, {
    refetchQueries: [
      {
        query: GET_ALL_STATUS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
      { query: GET_ONE_STATUS, variables: { id: parseInt(_id) } },
    ],
  })

  //QUERIES
  const {
    data: dataStatus,
    loading: loadingStatus,
    error: errorStatus,
  } = useQuery(GET_ONE_STATUS, {
    variables: {
      id: parseInt(_id),
    },
  })

  //FORM
  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  //FUNCTIONS
  const onSubmit = async (Data) => {
    const input = {
      name: Data.name,
      type: Data.type,
      description: Data.description,
      progress: parseInt(progressValue),
      color: Data.color,
    }

    showLoading()
    try {
      let msg = ''
      if (_id) {
        await updateMutation({ variables: { id: parseInt(_id), input } })
        msg = 'Estatus ha sido actualizado correctamente'
      } else {
        await createMutation({ variables: { input } })
        msg = 'Estatus ha sido creado correctamente'
      }
      return toastSweetAlert(
        { mode: 'ok', message: msg },
        history.push(backPage)
      )
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  //EFECTS
  useEffect(() => {
    if (!loadingStatus) {
      if (_id) {
        if (errorStatus) {
          return toastSweetAlert({
            mode: 'error',
            message: errorStatus.message,
          })
        }
        if (dataStatus !== undefined && dataStatus !== null) {
          const resp = dataStatus.getOneCatalogStatus

          if (resp.progress) setProgressValue(resp.progress)

          reset(resp)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataStatus, errorStatus])

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <Link
                  className="btn btn-migrates-white mb-3"
                  to={backPage}
                >
                  <i className="fas fa-long-arrow-alt-left" /> Atrás
                </Link>
                <h1 className="header-title">Estatus</h1>
              </div>
            </div>
          </div>
        }
        breadcrumb=""
        windowTitle={`${_id ? 'Editar' : 'Agregar'} status`}
      />
      <FormProvider {...methods}>
        <form className="pb-3 px-3 pt-0" onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`${_id ? 'Editar' : 'Agregar'} estatus`}
            btnSubmit
            btnSubmitText={`${_id ? 'Guardar cambios' : 'Guardar'}`}
            btnRedPath={backPage}
            btnRedTxt="Cancelar"
            errors={errors}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-12 col-sm-6">
                    <InputController
                      label="Nombre"
                      name="name"
                      placeholder="Nombre estatus"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-6">
                    <InputController
                      label="Tipo"
                      name="type"
                      placeholder="Tipo"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-12">
                    <InputController
                      label="Descripción"
                      name="description"
                      placeholder="Descripción"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-6 col-md-4">
                    <InputController
                      label={`Porcentaje de progreso (${progressValue}%)`}
                      name="progress"
                      placeholder="%progreso"
                      control={control}
                      inputType="range"
                      min="0"
                      max="100"
                      step="1"
                      changeAction={(e) => setProgressValue(e.target.value)}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-6 col-md-4">
                    <InputController
                      label="Color (Elige un color)"
                      name="color"
                      placeholder="Elige un color"
                      control={control}
                      type="color"
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}
export default StatusAdd
